import * as React from "react";
import { useWindowTile } from "./WindowTilesContext";

type ContextValue = ReturnType<typeof useWindowTile> & { isFocus: boolean };

const ctx = React.createContext<ContextValue | undefined>(undefined);

export const DesktopWindowProvider: React.FC<{ tileId: string; isFocus: boolean }> = ({
	tileId,
	isFocus,
	children,
}) => {
	const values = useWindowTile(tileId);

	const ctxValue = React.useMemo(() => {
		return {
			...values,
			isFocus,
		};
	}, [isFocus, values]);

	return <ctx.Provider value={ctxValue}>{children}</ctx.Provider>;
};

export const useDesktopWindow = () => {
	const context = React.useContext(ctx);
	if (!context) {
		throw new Error("Please use under DesktopWindowProvider!");
	}
	return context;
};
